/* AgVolution — adaptive breadcrumb.
   Makes every global breadcrumb (.breadcrum-container) take the background color
   of the content section directly below it, so the breadcrumb blends seamlessly
   into the hero/first section on Solutions and every other custom page.
   Text + chevron colors swap automatically (light on dark, dark on light).
   Re-runs on load and on shopify:section:load so it stays accurate in the editor. */
(function () {
  function parseRGB(s) {
    if (!s) return null;
    var m = s.match(/rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?/i);
    if (!m) return null;
    var a = m[4] === undefined ? 1 : parseFloat(m[4]);
    if (a === 0) return null;
    return [parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3])];
  }
  function relLum(r, g, b) {
    var a = [r, g, b].map(function (v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
  }
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, LINK: 1, NOSCRIPT: 1 };
  /* First child that actually renders — skip scripts/styles and 0-height nodes,
     so a leading <script> in a section doesn't make us give up and mis-default. */
  function firstRenderedChild(node) {
    var c = node.firstElementChild;
    while (c && (SKIP_TAGS[c.tagName] || c.offsetHeight === 0) && c.nextElementSibling) {
      c = c.nextElementSibling;
    }
    return (c && !SKIP_TAGS[c.tagName]) ? c : null;
  }
  /* True for product/media content we must NOT dive into — a product gallery
     image is not the section background. */
  function isMediaish(node) {
    var t = node.tagName;
    if (t === 'IMG' || t === 'VIDEO' || t === 'PICTURE' || t === 'SVG' || t === 'CANVAS') return true;
    var c = (node.className && node.className.baseVal !== undefined) ? node.className.baseVal : (node.className || '');
    return /media|image|gallery|thumbnail|product__|product-media|slider|swiper|deferred/i.test(c);
  }
  /* Read the effective background of the section below: prefer the outermost
     solid color. A background IMAGE only counts as a dark hero when it sits on a
     full-bleed, tall band (an actual hero) — not a small inline/product image.
     We stop descending as soon as we hit product/media content, so a white
     product page never mis-reads as dark. */
  function sectionBg(el) {
    var node = el, hops = 0, heroImg = false;
    var vw = window.innerWidth || document.documentElement.clientWidth || 1280;
    while (node && hops < 3) {
      var cs = getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden') break;
      var rgb = parseRGB(cs.backgroundColor);
      if (rgb) return { rgb: rgb }; /* solid color wins */
      if (cs.backgroundImage && cs.backgroundImage !== 'none') {
        if (node.offsetWidth >= vw * 0.9 && node.offsetHeight >= 240) heroImg = true;
      }
      var next = firstRenderedChild(node);
      if (next && isMediaish(next)) break;
      node = next;
      hops++;
    }
    return heroImg ? { image: true } : null;
  }
  function nextVisibleSibling(el) {
    var sib = el.nextElementSibling;
    while (sib && sib.offsetHeight === 0 && sib.nextElementSibling) sib = sib.nextElementSibling;
    return sib;
  }
  function apply() {
    var crumbs = document.querySelectorAll('.breadcrum-container');
    for (var i = 0; i < crumbs.length; i++) {
      var crumb = crumbs[i];
      var sec = nextVisibleSibling(crumb);
      if (!sec) continue;
      var info = sectionBg(sec);
      var rgb, dark;
      if (info && info.image) {
        rgb = [31, 31, 33]; /* full-bleed media hero → brand ink */
        dark = true;
      } else if (info && info.rgb) {
        rgb = info.rgb;
        dark = relLum(rgb[0], rgb[1], rgb[2]) < 0.5;
      } else {
        rgb = [255, 255, 255]; /* undetermined → light, matches the body/most sections */
        dark = false;
      }
      crumb.style.backgroundColor = 'rgb(' + Math.round(rgb[0]) + ',' + Math.round(rgb[1]) + ',' + Math.round(rgb[2]) + ')';
      crumb.classList.toggle('agv-on-dark', dark);
      crumb.classList.toggle('agv-on-light', !dark);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.addEventListener('load', apply);
  document.addEventListener('shopify:section:load', apply);
})();
